module.exports = __webpack_public_path__ + "static/media/value_prop_img_3.1ed78efc.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/value_prop_img_3.jpg
// module id = 1302
// module chunks = 0